import apiClient from "./api";
import { getApiAccessToken } from "./UserService";

const baseUrl = "/api/Deputies";

export interface DeputiesContractOption {
  id: number;
  name: string;
}

export interface DeputyUserOption {
  id: number;
  name: string;
}

export interface DeputyUser {
  userId: number;
  name: string;
  email?: string | null;
  awayStart?: string | null;
  awayEnd?: string | null;
  substituteUserId?: number | null;
  substituteOptions: DeputyUserOption[];
}

export interface DeputyRoleGroup {
  role: string;
  labelTranslationKey: string;
  defaultLabel: string;
  users: DeputyUser[];
}

export interface DeputiesResponse {
  availableContracts: DeputiesContractOption[];
  selectedContractId?: number | null;
  archiveEmail?: string | null;
  contractorArchiveEmail?: string | null;
  roleGroups: DeputyRoleGroup[];
}

export interface SaveDeputyRow {
  userId: number;
  awayStart?: string | null;
  awayEnd?: string | null;
  substituteUserId?: number | null;
}

export interface SaveDeputiesRequest {
  contractId: number;
  updateAllContracts: boolean;
  archiveEmail?: string | null;
  contractorArchiveEmail?: string | null;
  deputies: SaveDeputyRow[];
}

async function authHeader(): Promise<Record<string, string>> {
  const token = await getApiAccessToken();
  return { Authorization: `Bearer ${token}` };
}

export const getDeputies = async (
  addressSystemId: number,
  contractId?: number | null,
): Promise<DeputiesResponse> => {
  const headers = await authHeader();
  const response = await apiClient.get<DeputiesResponse>(
    `${baseUrl}/${addressSystemId}`,
    {
      headers,
      params: contractId ? { contractId } : undefined,
    },
  );
  return response.data;
};

export const saveDeputies = async (
  addressSystemId: number,
  request: SaveDeputiesRequest,
): Promise<DeputiesResponse> => {
  const headers = await authHeader();
  const response = await apiClient.put<DeputiesResponse>(
    `${baseUrl}/${addressSystemId}`,
    request,
    { headers },
  );
  return response.data;
};
